import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import styled from "styled-components";
import b from './img3/logooo.png';

const COLORS = {
  primaryDark: "#081a2f",
  primaryLight: "#edf3ef",
};

const MenuLabel = styled.label`

@media (min-width: 992px) {

 display:none;
  
}

position: fixed;
top: -2rem;
right: 1rem;
border-radius: 50%;
height: 6rem;
width: 4rem;
  cursor: pointer;
  z-index: 1000;
  text-align: center;
`;

const NavBackground = styled.div`
  position: fixed;
  top: 6.5rem;
  right: 6.5rem;
  backdrop-filter: blur(10px);

  background-image: radial-gradient(
    ${COLORS.primaryDark},
    ${COLORS.primaryLight}
  );

  height: 6rem;
  width: 6rem;
  border-radius: 50%;
  z-index: 600;

  transform: ${(props) => (props.clicked ? "scale(80)" : "scale(0)")};
  transition: transform 0.9s cubic-bezier(0.86, 0, 0.07, 1);
`;

const Icon = styled.span`
  position: relative;
  width: 3rem;
  height: 2px;
  background-color: white;
  display: inline-block;

  margin-top: 3.5rem;
  transition: all 0.3s;

  /* הקו האמצעי */
  background-color: ${(props) => (props.clicked ? "transparent" : "white")};

  &::before,
  &::after {
    content: "";
    position: absolute;
    left: 0;

    width: 3rem;
    height: 2px;
    background-color: white;

    transition: all 0.3s;
  }

  /* קו עליון */
  &::before {
    top: 0;
    transform: ${(props) =>
      props.clicked
        ? "rotate(45deg)"
        : "translateY(-0.8rem) rotate(0)"};
  }

  /* קו תחתון */
  &::after {
    top: 0;
    transform: ${(props) =>
      props.clicked
        ? "rotate(-45deg)"
        : "translateY(0.8rem) rotate(0)"};
  }
`;

const Navigation = styled.nav`
  height: 100vh;
  position: fixed;
  top:2rem;
  right:0;

  z-index: 700;

  width: ${(props) => (props.clicked ? "100%" : "0")};
  opacity: ${(props) => (props.clicked ? "1" : "0")};

  pointer-events: ${(props) => (props.clicked ? "all" : "none")};

  transition: width 1.2s, opacity 0.8s;
`;

const List = styled.ul`
  position: absolute;
  list-style: none;

  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  text-align: center;
  width: 100%;
`;

const ItemLink = styled(NavLink)`
  display: inline-block;
  font-size: 1.5rem;
  font-weight: 200;
  text-decoration: none;

  color: ${COLORS.primaryLight};

  padding: 1rem 2rem;

  background-image: linear-gradient(
    120deg,
    transparent 0%,
    transparent 50%,
    #fff 50%
  );

  background-size: 240%;
  transition: all 0.4s;

  &:hover,
  &:active {
    background-position: 100%;
    color: ${COLORS.primaryDark};
    transform: translateX(1rem);
  }
`;
 function web() {
  const fileName = "/תקנון-שימוש-באתר - רישוי עסקים ישראל.pdf";
  window.open(encodeURI(fileName), "_blank");
}
const scrollDown = () => {
  window.scrollBy({
    top: 400, // כמה לרדת
    behavior: "smooth",
  });
};



function HamburgerMenu() {
  const [click, setClick] = useState(false);
  const handleClick = () => setClick(!click);
  return (
    <>
      <MenuLabel htmlFor="navi-toggle" onClick={handleClick}>
        <Icon clicked={click}>&nbsp;</Icon>
      </MenuLabel>
      <NavBackground clicked={click}>&nbsp;</NavBackground>

      <head>

<script async src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-4942463590341754"
     crossorigin="anonymous"></script>

 </head>


      <Navigation clicked={click}>
        <List>
          <li>
            <ItemLink onClick={() => {
    handleClick();
    scrollDown();
  }} to="/">
              דף הבית
            </ItemLink>
          </li>
          <li>
            <ItemLink    onClick={() => {
    handleClick();
    scrollDown();
  }}  to="/customers ">
              מבין לקוחותינו
            </ItemLink>
          </li>
          <li>
            <ItemLink onClick={() => {
    handleClick();
    scrollDown();
  }} to="/about">
              אודות
            </ItemLink>
          </li>
          <li>
            <ItemLink onClick={() => {
    handleClick();
    scrollDown();
  }} to="/contact ">
             יצירת קשר
            </ItemLink>
          </li>
          <li>
            <ItemLink   onClick={() => {
    web();
    handleClick();
  }} to="/articles">
              תקנון האתר
            </ItemLink>
          </li>
          <li>
          
     <br></br>     <br></br>     <br></br>


          <img  src={b} alt="3" style={{ width: "250px" }} />
          </li>
        </List>



      </Navigation>


 
    </>
  );
}

export default HamburgerMenu;


/////background-color: ${COLORS.primaryLight};

